var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 -960 960 960","fill":"none"}},[_c('path',{attrs:{"d":"M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }